<template>
  <div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item">
        <md-field>
          <label for="sources">Sources</label>
          <md-select v-model="selectedSource" @md-selected="onSourceSelect($event)">
            <md-option value="all">All</md-option>
            <md-option v-for="source in sources" :value="source">{{source}}</md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <md-content class="md-scrollbar">
    <div v-if="this.telerium.length>=1">
      <md-table v-model="telerium"  :table-header-color="tableHeaderColor" :key="componentKey" ref="table">
        <md-table-row v-on:click="selectSwarmOnParent(item.swarm)" slot="md-table-row" slot-scope="{ item, index }">
          <md-table-cell md-label="Source">{{ item.source }}</md-table-cell>
          <md-table-cell md-label="Swarm">{{ item.swarm }}</md-table-cell>
          <md-table-cell md-label="viewers">{{ item.clients}}
            <small>
              <span class="text-info"
                    v-if="old_telerium.length >1  && old_telerium[index].clients -item.clients == 0">
                    &nbsp; 0
              </span>
              <span class="text-success"
                    v-else-if="old_telerium.length >1  && old_telerium[index].clients -item.clients > 0">
                <i class="fas fa-long-arrow-alt-up"></i>{{old_telerium[index].clients -item.clients}}
              </span>
              <span class="text-danger" v-else-if="old_telerium.length >1">
                <i class="fas fa-long-arrow-alt-down"></i>{{item.clients-old_telerium[index].clients}}
              </span>
          </small>
          </md-table-cell>
          <md-table-cell md-label="p2p rate">{{ Math.round(item.avg*100)/100 }} %
            <small>
              <span class="text-info"
                    v-if="old_telerium.length >1  && old_telerium[index].avg -item.avg == 0">
                0%
              </span>
              <span class="text-success"
                  v-else-if="old_telerium.length >1  && old_telerium[index].avg -item.avg > 0">
                      <i class="fas fa-long-arrow-alt-up"></i>
                {{Math.round((old_telerium[index].avg -item.avg)*100)/100}} %
              </span>
              <span class="text-danger" v-else-if="old_telerium.length >1">
                <i class="fas fa-long-arrow-alt-down"></i>{{Math.round((item.avg-old_telerium[index].avg)*100/100)}}%
              </span>
            </small>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </md-content>
  </div>
</template>

<script>
  import {API} from '../../services'
  import { mapGetters } from "vuex";

  export default {
    name: "ordered-table",
    props: {
      tableHeaderColor: {
        type: String,
        default: ""
      }
    },
    created: function () {
      // AFAZENDASDMCANAIS
      API.getBySwarms().then(
        response => {
          if (this.selectedSource != 'all') {
            this.telerium = response.data.filter(stream => stream.source.includes(this.selectedSource));;
          } else {
            this.telerium = response.data;
          }
          if (this.is_staff) {
            this.sources = [...new Set(response.data.map(item => item.source))];
          } else {
            API.getSources().then(
              response => {
                this.sources = response.data.data
              },
            );
          }
        },
      );
      this.timer = window.setInterval(this.updateSwarms,10000)
    },
    watch: {
      telerium: function(newVal, oldVal){
        this.old_telerium = oldVal
      }
    },
    beforeDestroy() {
      window.clearInterval(this.timer)
    },
    methods: {
      selectSwarmOnParent(id){
        this.$parent.$parent.$parent.swarm_selected = id;
        this.$parent.$parent.$parent.updateSwarmByBrowser();
        this.$parent.$parent.$parent.updateSwarmByTrackers();
        this.$parent.$parent.$parent.updateSwarmByCountry();
        this.$parent.$parent.$parent.updateSwarmByPlatform();
        this.$parent.$parent.$parent.updateSwarmByBrowserOnWin32();
        this.$parent.$parent.$parent.updateSwarmByBrowserOnWin64();
        this.$parent.$parent.$parent.updateSwarmByBrowserOnMacIntel();
        this.$parent.$parent.$parent.updateSwarmByBrowserOnLinux();
      },
      updateSwarms() {
        API.getBySwarms().then(
          response => {
            if (this.selectedSource != 'all') {
              this.telerium = response.data.filter(stream => stream.source.includes(this.selectedSource));;
            } else {
              this.telerium = response.data;
            }
          }
        );
      },
      filterByValue(array, string) {
        return array.filter(o =>
          Object.keys(o).some(k => o[k].toLowerCase().includes(string.toLowerCase())));
      },
      onSourceSelect(option) {
        this.updateSwarms();
      },
      cancelSwarms() {}
    },
    computed: {
      ...mapGetters(["is_staff"])
    },
    data() {
      return {
        telerium: [],
        old_telerium: [],
        selected: [],
        selectedSource: 'all',
        sources: [],
        componentKey: 0
      };
    }
  };
</script>

<style lang="scss" scoped>
  .md-content {
    max-height: 500px;
    overflow: auto;
  }
</style>
